module.exports = __webpack_public_path__ + "static/media/el_espectador.c9b5b186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/el_espectador.png
// module id = 542
// module chunks = 0